import { safeGradient } from "@/shared/utils/gradient-css";
import { isGradient } from "@components/color-picker/lib/detect";
import styled from "styled-components";
import type { IconStyledProps, IconWrapperStyledProps } from "../types";

export const IconWrapper = styled.div<IconWrapperStyledProps>`
  justify-content: ${({ $horizontalAlignment }) =>
    $horizontalAlignment || "inherit"};
  a,
  a:hover {
    text-decoration: none !important;
  }
  /* Mobile: same min(override, shape-based cap when capped [circle/square 40%, other 60%], original). When --combo-mobile-fill-cell (array 3+ per line), use 100% so icon is not resized. */
  .iconSizeContainer {
    @media screen and (max-width: 768px) {
      max-width: calc(
        min(
            var(--entity-mobile-width-override, 100%),
            calc(
              100% * (1 - var(--combo-mobile-media-capped, 0)) +
                var(--entity-mobile-cap-by-shape, 40%) *
                var(--combo-mobile-media-capped, 0)
            ),
            100%
          ) *
          (1 - var(--combo-mobile-fill-cell, 0)) + 100% *
          var(--combo-mobile-fill-cell, 0)
      );
    }
  }
`;

export const IconElement = styled.span<IconStyledProps>`
  font-size: var(--entity-size) !important;
  line-height: 1.5;
  ${({ $color }) => {
    if (isGradient($color)) {
      const safe = safeGradient($color);
      if (!safe) return `color: inherit !important;`;
      return `
        background-image: ${safe};
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        color: transparent !important;
      `;
    }
    return `color: ${$color || "inherit"} !important;`;
  }}
`;
